export default theme => ({
    content: {
        padding: '0 24px',
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        fontSize: 80,
        fontWeight: 'bold',
        lineHeight: '36px',
        marginBottom: 40,
        color: theme.palette.blue[600]
    },
    mainText: {
        maxWidth: 590,
        fontSize: 32,
        fontWeight: 'bold',
        lineHeight: '39px',
        textAlign: 'center',
        color: theme.palette.grey[900],
        marginBottom: 37,
        [theme.breakpoints.down('sm')]: {
            fontSize: 24
        }
    },
    additionalText: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 600,
        maxWidth: 625,
        color: theme.palette.grey[700],
        '& p': {
            lineHeight: '28px',
            margin: 0
        }
    },
    link: {
        fontWeight: 'bold',
        color: theme.palette.blue[600]
    },
    icon: {
        width: 110,
        height: 110,
        [theme.breakpoints.down('sm')]: {
            width: 60,
            height: 60
        }
    }
});
